<template>
  <CHeader class="bg-danger text-white py-3 pt-3">
    <div class="d-flex align-items-center w-100 px-3">
      <!-- Logo and text as link -->
      <router-link
          :to="homeRoute"
          class="d-flex align-items-center text-white text-decoration-none"
          style="gap: 0.75rem; line-height: 1.2;"
      >
        <img
            src="@/assets/logo.svg"
            alt="logo"
            style="height: 50px; object-fit: contain;"
        />
        <div class="d-flex flex-column justify-content-center">
          <p class="mb-0 font-weight-bold">มหาวิทยาลัยแม่ฟ้าหลวง</p>
          <p class="mb-0" style="font-size: 1.1rem;">Mae Fah Luang University</p>
        </div>
      </router-link>

      <!-- Right-side nav and dropdown -->
      <div class="ml-auto d-flex align-items-center">
        <!-- NavLink to Home -->
        <router-link :to="homeRoute" class="text-white mr-4 text-decoration-none">
          Home
        </router-link>

        <!-- Pass user to dropdown -->
        <TheHeaderDropdownAccnt :user="user" class="pr-3" />
      </div>
    </div>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  props: {
    user: Object
  },
  components: {
    TheHeaderDropdownAccnt
  },
  computed: {
    homeRoute() {
      const role = this.user?.role?.role_name
      switch (role) {
        case 'admin':
          return '/admin/admin_home'
        case 'committee':
          return '/committee/committee_home'
        case 'user':
        case 'candidate':
          return '/Home'
        default:
          return '/login'
      }
    }
  }
}
</script>
